export default __webpack_public_path__ + "static/media/screen5.7ef9679d.png";